<template>
  <div class="Site PageBox" style="background-color: var(--background-main)">
    <van-nav-bar
      fixed
      :border="false"
      :title="stepInfo.title"
      left-arrow
      style=""
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <div class="step-box">
        <div class="title">
          <img :src="`./static/icon/${Theme}/icon-step.png`" height="50">
          <span>{{$t('Share[2][0]')}}<i>{{$t('Share[2][1]',{num: stepInfo.dayNumber})}}</i></span>
        </div>
        <div class="step">
          <ul>
            <li v-if="stepInfo.step1">
              <i>1</i>
              <div class="con">{{stepInfo.step1}}</div>
            </li>
            <li v-if="stepInfo.step2">
              <i>2</i>
              <div class="con">{{stepInfo.step2}}</div>
            </li>
            <li v-if="stepInfo.step3">
              <i>3</i>
              <div class="con">{{stepInfo.step3}}</div>
            </li>
            <li v-if="stepInfo.step4">
              <i>4</i>
              <div class="con">{{stepInfo.step4}}</div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="stepInfo.step1" class="step-item">
        <img :src="`./static/images/${Theme}/step1.png`" height="14">
        <p>{{stepInfo.step1}}</p>
      </div>
      <div v-if="stepInfo.step2" class="step-item">
        <img :src="`./static/images/${Theme}/step2.png`" height="14">
        <p>{{stepInfo.step2}}</p>
      </div>
      <div v-if="stepInfo.step3" class="step-item">
        <img :src="`./static/images/${Theme}/step3.png`" height="14">
        <p>{{stepInfo.step3}}</p>
        <van-form @submit="onSubmit">
          <van-field v-show="false" :value="stepInfo.id" name="id" readonly />
          <van-field v-if="stepInfo.type=='link'" v-model="formUrl" name="url" size="large" :border="false" :placeholder="$t('Share[4][1]')" style="background-color:#ffece7;margin: 20px 0;border-radius: 5px;border:1px #ffd6cb solid" />
          <div v-if="stepInfo.type=='withdraw'" class="upload-list">
            <van-field v-show="false" :value="formScreenshot1" name="examine_demo[0]" />
            <van-field v-show="false" :value="formScreenshot2" name="examine_demo[1]" />
            <div class="item">
              <van-uploader v-model="uploaderImg1" name="img1" max-count="1" :preview-options="previewOptions1" upload-icon="plus" image-fit="contain" :after-read="afterRead" />
              <p>{{$t('Share[3][0]')}}</p>
            </div>
            <div class="item">
              <van-uploader v-model="uploaderImg2" name="img2" max-count="1" :preview-options="previewOptions2" upload-icon="plus" image-fit="contain" :after-read="afterRead" />
              <p>{{$t('Share[3][1]')}}</p>
            </div>
          </div>
          <div v-if="stepInfo.type=='img'" class="upload-list">
            <van-field v-show="false" :value="formScreenshot1" name="examine_demo" />
            <div class="item" style="width: 100px;flex:none">
              <van-uploader v-model="uploaderImg1" name="img1" max-count="1" :preview-options="previewOptions1" upload-icon="plus" image-fit="contain" :after-read="afterRead" />
            </div>
          </div>
          <div class="tips">
            {{$t('Share[3][2]')}}
          </div>
          <a v-if="stepInfo.type=='withdraw'" class="example" href="javascript:;" @click="showExample=true">{{$t('Share[4][2]')}}</a>
          <van-button round block color="linear-gradient(to right,#ff4c48,#ff823f)" style="font-size:16px">{{$t('Share[5]')}}</van-button>
        </van-form>
      </div>
      <div v-if="stepInfo.step4" class="step-item">
        <img :src="`./static/images/${Theme}/step4.png`" height="14">
        <p>{{stepInfo.step4}}</p>
        <span>{{$t('Share[3][3]')}}</span>
      </div>
    </div>
    <van-image-preview v-model="showExample" :images="exampleImg" closeable />
  </div>
</template>

<script>
export default {
  name: 'ShareStep',
  components: {

  },
  props: ['shareId'],
  data() {
    return {
      stepInfo: '',
      formUrl: '',
      formScreenshot1: '',
      formScreenshot2: '',
      uploaderImg1: [],
      uploaderImg2: [],
      previewOptions1: {
        images: []
      },
      previewOptions2: {
        images: []
      },
      showExample: false,
      exampleImg: []
    }
  },
  computed: {
    screenshotUrl1() {
      return this.uploaderImg1.length?this.uploaderImg1[0].url:''
    },
    screenshotUrl2() {
      return this.uploaderImg2[0].url
    }
  },
  watch: {

  },
  created() {
    this.$Model.GetShareInfo({id: this.shareId},data=>{
      if(data.code==1){
        this.stepInfo = data.info
        if(data.info.examine_demo){
          this.exampleImg = data.info.examine_demo.map(item=>this.$store.state.InitData.setting.up_url+item)
        }
      }
    })
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    onSubmit(json) {
      if(this.stepInfo.type=='withdraw'){
        if(!this.formScreenshot1){
          this.$Dialog.Toast(this.$t('Share[4][0]'))
          return
        }
        if(!this.formScreenshot2){
          this.$Dialog.Toast(this.$t('Share[4][0]'))
          return
        }
      }
      if(this.stepInfo.type=='img'){
        if(!this.formScreenshot1){
          this.$Dialog.Toast(this.$t('Share[4][0]'))
          return
        }
      }
      if(this.stepInfo.type=='link'){
        if(!this.formUrl){
          this.$Dialog.Toast(this.$t('Share[4][1]'))
          return
        }
      }
      this.$Model.SubmitShare(json,data=>{
        if(data.code==1){
          this.$Model.GetShareInfo({id: this.shareId},data=>{
            if(data.code==1){
              this.stepInfo = data.info
            }
          })
          this.formUrl = ''
          this.formScreenshot1 = ''
          this.formScreenshot2 = ''
          this.uploaderImg1 = []
          this.uploaderImg2 = []
          this.previewOptions1 = {
            images: []
          }
          this.previewOptions2 = {
            images: []
          }
        }
      })
    },
    afterRead(file,detail) {
      file.status = 'uploading'
      file.message = this.$t('upload[0]')
      if(file.length){
        file.forEach(item=>{
          if (!item.file.type.match(/image/)){
            item.status = 'failed'
            item.message = this.$t('upload[1]')
            return;
          }
          this.compressImg(item,detail)
        })
      }else{
        if (!file.file.type.match(/image/)){
          file.status = 'failed'
          file.message = this.$t('upload[1]')
          return;
        }
        this.compressImg(file,detail)
      }
    },
    compressImg(file,detail) {
      this.$Util.CompressImg(file.file.type,file.content,750,(image)=>{
        let param = new FormData();
        param.append('token',localStorage['Token']);
        param.append('type',3);
        param.append('image',image,file.file.name);
        this.$Model.UploadImg(param,(data)=>{
          if(data.code==1){
            file.message = this.$t('upload[2]')
            file.status = 'success'
            file.url = data.url
            if(detail.name=='img1'){
              this.formScreenshot1 = data.url
              this.previewOptions1 = {
                images: [this.$store.state.InitData.setting.up_url+data.url]
              }
            }
            if(detail.name=='img2'){
              this.formScreenshot2 = data.url
              this.previewOptions2 = {
                images: [this.$store.state.InitData.setting.up_url+data.url]
              }
            }
          }else{
            file.status = 'failed'
            file.message = this.$t('upload[3]')
          }
        });
      })
    },
  }
}
</script>
<style scoped>
.step-box {
  background-color: #ffede8;
  border-radius: 10px;
  padding: 15px 13px;
  margin: 10px 15px;
  line-height: 1;
}
.step-box .title{
  display: flex;
  align-items: center;
}
.step-box .title img{
  z-index: 2;
}
.step-box .title span{
  background: linear-gradient(to right,#ff4c48,#ff823f);
  color: #fff;
  margin-left: -40px;
  padding: 7px 15px 7px 45px;
  font-size: 15px;
  border-radius: 100px;
  font-weight: 600;
}
.step-box .title span i{
  font-size: 12px;
  opacity: .7;
  margin-left: 8px;
  font-weight: 400;
}
.step-box .step{
  border-left: 1px var(--border-color-active) solid;
  margin: 0 0 35px 24px;
}
.step-box .step ul{
  margin-left: -13px;
  display: inline-block;
}
.step-box .step li{
  display: flex;
  align-items: center;
}
.step-box .step li+li{
  margin-top: 10px;
}
.step-box .step li:last-child{
  margin-bottom: -35px;
}
.step-box .step li i{
  width: 24px;
  height: 24px;
  line-height: 20px;
  color: var(--color-white);
  background-color: var(--color-active);
  border-radius: 100%;
  text-align: center;
  border: 2px #ffede8 solid;
}
.step-box .step li .con{
  padding: 15px;
  background-color: var(--background-main);
  flex: 1;
  border-radius: 6px;
  border: 1px #ffd6cb solid;
  box-shadow: 0 2px 5px rgba(252, 95, 53, .1);
  line-height: 1.5;
  min-height: 70px;
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 15px;
}
.step-box .step li .con:before{
  content: '';
  border: 9px transparent solid;
  border-right-color: #ffd6cb;
  left: -18px;
  position: absolute;
}
.step-box .step li .con:after{
  content: '';
  border: 8px transparent solid;
  border-right-color: #fff;
  left: -16px;
  position: absolute;
}
.step-item{
  padding: 20px 15px;
  background-color: var(--background-main);
  border: 1px #ffd6cb solid;
  box-shadow: 0 3px 8px rgba(252, 95, 53, .1);
  border-radius: 10px;
  margin: 15px;
  text-align: center;
}
.step-item>img{
  display: block;
  margin: 0 auto;
}
.step-item>p{
  margin-top: 15px;
  font-weight: 600;
  font-size: 15px;
  line-height: 1.5;
}
.step-item>span{
  color: var(--color-active);
}
.step-item:last-child{
  margin-bottom: 50px;
}
.upload-list {
  display: flex;
  font-size: 12px;
  margin: 20px 0;
  justify-content: center;
}
.upload-list .item{
  flex: 1;
  line-height: 1;
}
.upload-list .item+.item{
  margin-left: 15px;
}
.van-uploader{
  display: block;
}
.van-uploader>>>.van-uploader__upload,.van-uploader>>>.van-uploader__preview{
  margin-right: 0;
  background-color: #ffece7;
  width: 100%;
  height: 100px;
  border-radius: 5px;
  overflow: hidden;
}
.van-uploader>>>.van-uploader__preview-image{
  width: 100%;
  height: 100%;
}
.van-uploader>>>.van-uploader__upload-icon{
  color: var(--color-active);
  font-size: 26px;
}
.tips{
  line-height: 1;
  font-size: 12px;
  color: var(--color-active);
  margin-bottom: 20px;
}
.example {
  color: #1989fa;
  text-decoration: underline;
  line-height: 1;
  margin-bottom: 20px;
  display: inline-block;
}
</style>